import React from "react";
import BaseDetails, { DetailRow } from "./baseDetails";

export default function modelDataCopyDetails({ row }) {
    return (
        <BaseDetails row={row}>
            <DetailRow label="Source">
                {row.source_model_name}
            </DetailRow>
            <DetailRow label="Destination">
                {row.destination_name}
            </DetailRow>
            <DetailRow label="New Name">
                <span className="font-medium">{row.new_model_name}</span>
            </DetailRow>
        </BaseDetails>
    );
}
